/** Mois proposés dans le rapport de consommation IA : le mois courant et les 11 précédents (AAAA-MM, UTC). */
export function recentMonths(count = 12, now = new Date()): string[] {
  return Array.from({ length: count }, (_, index) => {
    const date = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - index, 1));
    return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}`;
  });
}

export function monthLabel(month: string): string {
  const [year, monthIndex] = month.split('-').map(Number) as [number, number];
  const label = new Date(Date.UTC(year, monthIndex - 1, 1)).toLocaleDateString('fr-FR', { month: 'long', year: 'numeric', timeZone: 'UTC' });
  return label.charAt(0).toUpperCase() + label.slice(1);
}

export function formatEuros(value: number): string {
  // Sous 1 €, deux décimales ne suffisent pas à distinguer de petits montants.
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: value > 0 && value < 1 ? 4 : 2 }).format(value);
}

export function formatTokens(value: number): string {
  if (value >= 1_000_000) return `${(value / 1_000_000).toLocaleString('fr-FR', { maximumFractionDigits: 1 })} M`;
  if (value >= 1_000) return `${(value / 1_000).toLocaleString('fr-FR', { maximumFractionDigits: 1 })} k`;
  return value.toLocaleString('fr-FR');
}

/** Niveau d'alerte du quota : à surveiller dès 80 %, atteint à 100 %. */
export function quotaLevel(ratio: number | null): 'none' | 'ok' | 'warning' | 'reached' {
  if (ratio === null) return 'none';
  if (ratio >= 1) return 'reached';
  return ratio >= 0.8 ? 'warning' : 'ok';
}
